import React, { useState } from "react";
import { FaqBlackArrow } from "../common/Icon";
import {
  Accordion,
  AccordionHeader,
  AccordionBody,
} from "@material-tailwind/react";
import { faqDataLeft, faqDataRight } from "../common/Helper";

const FrequentlyAskedQuestions = () => {
  // const CUSTOM_ANIMATION = {
  //   mount: { scale: 1 },
  //   unmount: { scale: 0.9 },
  // };
  // const [open, setOpen] = useState("");
  // const handleOpen = (value) => {
  //   setOpen(open === value ? "" : value);
  //   setOpen2("");
  // };
  // const [open2, setOpen2] = useState("");
  // const handleOpenRight = (value) => {
  //   setOpen2(open2 === value ? "" : value);
  //   setOpen("");
  // };

  const [activeIndex, setActiveIndex] = useState(null);
  const [activeIndex2, setActiveIndex2] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
    setActiveIndex2("");
  };
  const toggleAccordion2 = (index) => {
    setActiveIndex2(activeIndex2 === index ? null : index);
    setActiveIndex("");
  };
  return (
    <>
      <div className="faq_accordion ">
        <p className="font-bold text-[14px] 3xl:text-lg pt-[22px] mb-[7px]">
          Frequently asked questions
        </p>
        <p className="font-normal text-[12px] 3xl:text-sm text-black opacity-70">
          Still searching for answers? Take a look at these frequently asked
          questions.
        </p>
        {/* <div className="pt-[11px] pb-5 pr-2">
          <div className="flex flex-wrap flex-col md:flex-row">
            <div className="w-full md:w-1/2 md:pr-5">
              {faqDataLeft.map((value, index) => (
                <Accordion
                  key={index}
                  className={`duration-300  ${
                    open === index
                      ? "pl-[5px] border-l-[4px] border-[#6F6AF8] bg-[#FBFBFF] "
                      : ""
                  }`}
                  open={open === index}
                  animate={CUSTOM_ANIMATION}
                  icon={<FaqBlackArrow id={index} open={open} />}>
                  <AccordionHeader
                    className="lg:py-[26px] md:mt-5"
                    onClick={() => handleOpen(index)}>
                    <span className="font-extrabold text-base text-start max-w-[380px]">
                      {value.questions}
                    </span>
                  </AccordionHeader>
                  <AccordionBody className="pt-0">
                    <span className="font-normal text-xs text-black opacity-70">
                      {value.answers}
                    </span>
                  </AccordionBody>
                </Accordion>
              ))}
            </div>
            <div className="w-full md:w-1/2 md:pl-5">
              {faqDataRight.map((value, index) => (
                <Accordion
                  key={index}
                  className={`duration-300 ${
                    open2 === index
                      ? "pl-[5px] border-l-[4px] border-[#6F6AF8] bg-[#FBFBFF]"
                      : ""
                  }`}
                  open={open2 === index}
                  animate={CUSTOM_ANIMATION}
                  icon={<FaqBlackArrow id={index} open={open2} />}>
                  <AccordionHeader
                    className="lg:py-[26px] md:mt-5"
                    onClick={() => handleOpenRight(index)}>
                    <span className="font-extrabold text-base text-start max-w-[380px]">
                      {value.questions}
                    </span>
                  </AccordionHeader>
                  <AccordionBody className="pt-0">
                    <span className="font-normal text-xs text-black opacity-70">
                      {value.answers}
                    </span>
                  </AccordionBody>
                </Accordion>
              ))}
            </div>
          </div>
        </div> */}
        <div className="mt-[11px] pb-5 pr-2 xl:mt-4 overflow-y-auto h-[calc(100vh-280px)]  md:h-[calc(100vh-200px)] overflow_x_scroll_style">
          <div className="flex flex-wrap flex-col md:flex-row">
            <div className="w-full md:w-1/2 md:pr-5">
              {faqDataLeft.map((value, index) => (
                <div
                  key={index}
                  className={` faq-wrapper text-white transition border-l-[4px] border-l-transparent ease-in-out duration-300   my-3 md:my-[10px] py-2 sm:py-3 lg:pt-6 lg:pb-3 bg-transparent mb-0   ${
                    activeIndex === index
                      ? " !border-l-[#6F6AF8] !bg-[#FBFBFF] transition-all duration-500 pl-4"
                      : ""
                  } `}>
                  <div className=" flex items-center justify-between md:justify-normal 2xl:justify-between">
                    <div>
                      <div className="flex justify-between items-center">
                        <h3
                          className={`${
                            activeIndex === index ? "common-text-gradient" : ""
                          } font-bold text-black text-base 3xl:text-lg text-start max-w-[380px] `}>
                          {value.questions}
                        </h3>
                      </div>

                      <div
                        className={`overflow-hidden  max-h-full   transition-all ease-in-out duration-200 pt-6 ${
                          activeIndex === index
                            ? "h-[70px]"
                            : "h-0 border-b border-solid border-b-[#F2F2F2]"
                        }`}>
                        <p className="font-normal text-xs 3xl:text-sm text-black opacity-70 pb-2">
                          {value.answers}
                        </p>
                      </div>
                    </div>
                    <span
                      onClick={() => toggleAccordion(index)}
                      className={` transform cursor-pointer transition-all ease-in-out duration-300 mr-3 ${
                        activeIndex === index
                          ? "rotate-[360deg] transform "
                          : "  rotate-[270deg] transform mb-6"
                      }`}>
                      <FaqBlackArrow />
                    </span>
                  </div>
                </div>
              ))}
            </div>
            <div className="w-full md:w-1/2 md:pl-2 ">
              {faqDataRight.map((value, index) => (
                <div
                  key={index}
                  className={` faq-wrapper text-white transition border-l-[4px] border-l-transparent ease-in-out duration-300   my-3 md:my-[10px] py-2 sm:py-3 lg:pt-6 lg:pb-3 bg-transparent mb-0  ${
                    activeIndex2 === index
                      ? " !border-l-[#6F6AF8] !bg-[#FBFBFF] transition-all duration-500 pl-4"
                      : ""
                  } `}>
                  <div className=" flex items-center justify-between md:justify-normal 2xl:justify-between">
                    <div>
                      <div className="flex justify-between items-center">
                        <h3
                          className={`${
                            activeIndex2 === index ? "common-text-gradient" : ""
                          } font-bold text-black text-base 3xl:text-lg text-start  `}>
                          {value.questions}
                        </h3>
                      </div>

                      <div
                        className={`overflow-hidden max-w-full transition-all ease-in-out duration-200  pt-6 ${
                          activeIndex2 === index
                            ? "h-[70px]"
                            : "h-0 border-b border-solid border-b-[#F2F2F2]"
                        }`}>
                        <p className="font-normal text-xs 3xl:text-sm text-black opacity-70 pb-2">
                          {value.answers}
                        </p>
                      </div>
                    </div>
                    <span
                      onClick={() => toggleAccordion2(index)}
                      className={`  cursor-pointer transform transition-all ease-in-out duration-300 mr-3 ${
                        activeIndex2 === index
                          ? "rotate-[360deg] transform "
                          : "  rotate-[270deg] transform mb-6"
                      }`}>
                      <FaqBlackArrow />
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FrequentlyAskedQuestions;
